// extracted by mini-css-extract-plugin
export const root = "inquire-modal-module--root--1apap";
export const modalIsOpen = "inquire-modal-module--modalIsOpen--Zpb-f";
export const footer = "inquire-modal-module--footer--2mIL0";
export const contact = "inquire-modal-module--contact--1qDqQ";
export const development = "inquire-modal-module--development--3BnJn";
export const marketing = "inquire-modal-module--marketing--jH9or";